import { render, staticRenderFns } from "./additionalWorkAdd.vue?vue&type=template&id=cb19d018&"
import script from "./additionalWorkAdd.vue?vue&type=script&lang=js&"
export * from "./additionalWorkAdd.vue?vue&type=script&lang=js&"
import style0 from "./additionalWorkAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports